
import React, { useEffect, useState } from 'react';
// import ImageGallery from "react-image-gallery";
// import "react-image-gallery/styles/css/image-gallery.css";
import "react-image-gallery/styles/css/image-gallery.css";
import './batman.css';
// import { TextareaAutosize } from '@material-ui/core';
import { getloginviewprofile, getmyprofile, getviewprofile, savewishlists, sendphotorequest, updatecount, userpackagedetail, userhoroscoperequest } from "../action/user";
// import logo from '../../assests/images/1.jpg';
import { useNavigate, useParams } from "react-router-dom";
import config from "../../lib/config";

import CancelIcon from '@mui/icons-material/Cancel';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import whyeliteLeft from "../../assests/images/whyelite-left.svg";
import whyeliteRight from "../../assests/images/whyelite-right.png";
import Tabp from '../../ui/tabpanel';
import ImageSlider from '../sidebar/ImageSlider';
import FavoriteIcon from '@mui/icons-material/Favorite';
import swal from "sweetalert";
import { calculateAge } from "../../utils/calculateAge";

function Freesearch() {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        height: 'auto',
        bgcolor: 'background.paper',
        // border: '2px solid #ff6ed',
        boxShadow: 24,
        p: 4,
        borderRadius: '25px'
    };
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const notify = () => toast("Saved Successfully!");
    // const [registers, setRegisters]=useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const [height1, setHeight] = useState(window.innerHeight);
    const { id } = useParams();
    const [post, setViewed] = useState({});
    const initial = {
        a1: "",
        a2: "",
        a3: "",
        a4: "",
        a5: "",
        a6: "",
        a7: "",
        a8: "",
        a9: "",
        a10: "",
        a11: "",
        a12: "",

        r1: "",
        r2: "",
        r3: "",
        r4: "",
        r5: "",
        r6: "",
        r7: "",
        r8: "",
        r9: "",
        r10: "",
        r11: "",
        r12: "",
    }

    const [box, setBox] = useState(initial);

    const {

        a1,
        a2,
        a3,
        a4,
        a5,
        a6,
        a7,
        a8,
        a9,
        a10,
        a11,
        a12,

        r1,
        r2,
        r3,
        r4,
        r5,
        r6,
        r7,
        r8,
        r9,
        r10,
        r11,
        r12

    } = box

    const [profileimg, setprofileimg] = useState([]);
    const [profileimg1, setprofileimg1] = useState([]);
    const [membership, setmembership] = useState(false);
    const [savenone, setsavenone] = useState("block");
    const [createwishlistbtn, setcreatewishlistbtn] = useState("inline-block");
    const [moredetailbtn, setmoredetailbtn] = useState("show");
    const [userpackages, setuserpackages] = useState({});
    // const[jathagam,setjathagam]=useState()
    const [canViewFullProfile, setCanViewFullProfile] = useState(false);






    const navigate = useNavigate();

    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }

    console.log("postttttttttt", post)

    const [showPopup, setShowPopup] = useState(false);

    const togglePopup = () => {
        // Pop up 의 open/close 상태에 따라
        setShowPopup(!showPopup);
    };

    const closeModal = (e) => {

        // console.log(e.target);
        if (e.target.className === "popup") {
            togglePopup();
        }
    };



    const show = () => {
        if (localStorage.user_token) {
            // console.log(Boolean(userpackages),userpackages,"userpackagesuserpackagesuserpackagesuserpackages")
            if ("package" in userpackages) {

                // 
                // console.log(typeof(localStorage.packagedetail),"hgfjhgjhfgdsjhfgdshjgjhg")
                togglePopup();
            } else {
                setmembership(false);
                window.location = "/payment";
            }
        } else {
            setmembership(false);
            window.location = "/registration";
        }
    }

    const showprofile = async () => {
        await updatecount(post._id);
        setmembership(true);
        setsavenone("none");
        togglePopup();
    }

    const savefavprofile = async () => {
        await savewishlists(post._id);
        setcreatewishlistbtn("none");
        notify()
    }

    const photorequest = async () => {
        await sendphotorequest(post._id);
    }


    useEffect(() => {

        // console.log(width);

        // console.log(height1);
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [hasMembership, setHasMembership] = useState(false);

    const getLoggedInData = async () => {
        const token = localStorage.getItem("user_token");
        if (!token) {
            setIsLoggedIn(false);
            setHasMembership(false);
            return;
        }
        try {
            setIsLoggedIn(true);
            if (post._id) {
                if (localStorage.getItem("user_id") === post._id) {
                    setcreatewishlistbtn("none");
                }
            }
            // Fetch the logged-in user's profile
            const user = await getmyprofile();

            if (user?.userValue) {
                // Check membership status
                if (user.userValue.membership && user.userValue.membership.trim() !== "") {
                    setHasMembership(true);
                } else {
                    setHasMembership(false);
                }
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
            setIsLoggedIn(false);
            setHasMembership(false);
        }
    };

    useEffect(() => {
        getLoggedInData();
    })

    const BlurWrapper = ({ children, condition, blurLevel = 4 }) => {
        return (
            <div style={{
                filter: condition ? 'none' : `blur(${blurLevel}px)`,
                pointerEvents: condition ? 'auto' : 'none',
                userSelect: condition ? 'auto' : 'none'
            }}>
                {children}
            </div>
        );
    };

    const getUserData = async () => {
        // if (localStorage.user_token) {

        // } else {

        // }


        if (localStorage.user_token) {
            // alert('gfdfgfgd')
            var test = await getloginviewprofile(id);
            console.log(test, "sss")
            // 
            console.log(test.userValue.userValue, "sdjhgfvjhsdfgjh");
            setViewed(test.userValue.userValue);

            const jathagamView = test.userValue.userValue.jathagamview;
            if (jathagamView === "yes") {
                setCanViewFullProfile(true);
            } else {
                setCanViewFullProfile(false);
            }

            var boxitems = test.userValue.userValue;
            Allboxitemss(boxitems.a1, boxitems.a2, boxitems.a3, boxitems.a4, boxitems.a5, boxitems.a6,
                boxitems.a7, boxitems.a8, boxitems.a9, boxitems.a10, boxitems.a11, boxitems.a12,
                boxitems.r1, boxitems.r2, boxitems.r3, boxitems.r4, boxitems.r5, boxitems.r6,
                boxitems.r7, boxitems.r8, boxitems.r9, boxitems.r10, boxitems.r11, boxitems.r12)
            // Allboxitemss("a2", test.userValue.userValue.a2)

            // setViewed(test.userValue.userValue);

            // const primages = test.userValue.userValue.photopath.map(e => config.API+"/images/user/"+e);
            // setprofileimg(primages);
            setprofileimg1(test.userValue.userValue.photopath[0])
            console.log(test.userValue.userValue.photopath[0], "profileimg1profileimg1profileimg1")
            if (test.userValue.userValue.photopath.length && test.userValue.userValue.photopath[0]) {
                setprofileimg(test.userValue.userValue.photopath.map(url => ({
                    original: config.API + `/images/user/${url}`,
                    // thumbnail: config.API + `/images/user/${url}`,
                    originalHeight: "200",
                    originalWidth: "200",
                    thumbnailHeight: "50",
                })))
            }
            if (test.userValue.whishlisted) {
                setcreatewishlistbtn("none");
            } else {
                setcreatewishlistbtn("inline-block");
            }

            if (test.userValue.viewlisted) {
                setmembership(true);
                setsavenone("none");
            } else {
                setsavenone("block");
            }
            var userdetail = await userpackagedetail();
            if (userdetail.success) {
                setuserpackages(userdetail.userValue)
                setmoredetailbtn("Show more details");
                // Check if user has membership and remaining count
                if (userdetail.userValue && userdetail.userValue.remainingcount > 0) {
                    // Call updatecount only once when user views profile with membership
                    await updatecount(id);

                    // Refresh package details after updating count
                    const updatedDetail = await userpackagedetail();
                    if (updatedDetail.success) {
                        setuserpackages(updatedDetail.userValue);
                    }
                }
            } else {
                setmoredetailbtn("To purchase membership");
            }
        } else {

            var test = await getviewprofile(id);
            console.log(test, "ss")

            setViewed(test.userValue);
            setmoredetailbtn("Click here to become a member and contact them ");

            if (test.userValue.photopath.length && test.userValue.photopath[0]) {
                setprofileimg(test.userValue.photopath.map(url => ({
                    original: config.API + `/images/user/${url}`,
                    // thumbnail: config.API + `/images/user/${url}`,
                    // originalHeight: "200",
                    // originalWidth: "200",
                    thumbnailHeight: "70",

                })))
            }
        }


        // var test =  await getregister();
        // 
        // console.log(test, "bdfgfdgdf");
        // setRegisters(test.userValue);

    };
    // if (post.n_marriage = "Marriage") {

    // }

    // console.log(post  , "sdjhgfvjhsdfgjh");
    const protimages = [
        "https://cdn.stocksnap.io/img-thumbs/960w/PS7M4VMB9P.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/SVSBXHN1OU.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/KLSTPV1LBV.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/N06ELOLAT9.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/YN0MX9OUSY.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/JVBWZNCQLW.jpg",
        "https://cdn.stocksnap.io/img-thumbs/960w/LN6MZNMBUR.jpg"
    ];
    const fhkjx = protimages.map(url => ({
        original: `${url}`,
        // thumbnail: `${url}`,
        originalHeight: "200",
        originalWidth: "200",
        thumbnailHeight: "50",


    }))



    // console.log(post.a1, "uttttttt");

    function Allboxitemss(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12,
        r1, r2, r3, r4, r5, r6, r7, r8, r9, r10, r11, r12) {


        // const tamil_lang = [
        //     'வி',
        //     'கே',
        //     'ல',
        //     'செ',
        //     'பு',
        //     'ச',
        //     'ரா',
        //     'சனி',
        //     'சூ',
        //     'சு',
        //     'மா',
        //     'வ'
        // ];
        const tamil_lang = [
            'J',
            'K',
            'L',
            'Mar',
            'Me',
            'Mo',
            'Ra',
            'Sa',
            'Su',
            'Ve',
            'Man',
            'Va'
        ];

        // var text11 = "5/8";
        // const newarray111 = text11.split("/");
        const tamillang = ["J", "K", "L", "Mar", "Me", "Mo", "Ra", "Sa", "Su", "Ve", "Man", "Va"];

        // Add safety checks for all variables
        const newarray = (a1 || "").split(",");
        const final = newarray.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray1 = (a2 || "").split(",");
        const final1 = newarray1.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray2 = (a3 || "").split(",");
        const final2 = newarray2.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray4 = (a4 || "").split(",");
        const final4 = newarray4.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray5 = (a5 || "").split(",");
        const final5 = newarray5.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray6 = (a6 || "").split(",");
        const final6 = newarray6.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray7 = (a7 || "").split(",");
        const final7 = newarray7.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray8 = (a8 || "").split(",");
        const final8 = newarray8.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray9 = (a9 || "").split(",");
        const final9 = newarray9.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray10 = (a10 || "").split(",");
        const final10 = newarray10.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray11 = (a11 || "").split(",");
        const final11 = newarray11.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarray12 = (a12 || "").split(",");
        const final12 = newarray12.map((e) => { return e ? tamillang[e - 1] : "" });

        // Rasi values
        const newarrayr1 = (r1 || "").split(",");
        const finalr1 = newarrayr1.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr2 = (r2 || "").split(",");
        const finalr2 = newarrayr2.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr3 = (r3 || "").split(",");
        const finalr3 = newarrayr3.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr4 = (r4 || "").split(",");
        const finalr4 = newarrayr4.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr5 = (r5 || "").split(",");
        const finalr5 = newarrayr5.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr6 = (r6 || "").split(",");
        const finalr6 = newarrayr6.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr7 = (r7 || "").split(",");
        const finalr7 = newarrayr7.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr8 = (r8 || "").split(",");
        const finalr8 = newarrayr8.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr9 = (r9 || "").split(",");
        const finalr9 = newarrayr9.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr10 = (r10 || "").split(",");
        const finalr10 = newarrayr10.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr11 = (r11 || "").split(",");
        const finalr11 = newarrayr11.map((e) => { return e ? tamillang[e - 1] : "" });

        const newarrayr12 = (r12 || "").split(",");
        const finalr12 = newarrayr12.map((e) => { return e ? tamillang[e - 1] : "" });

        var data = {
            "a1": final,
            "a2": final1,
            "a3": final2,
            "a4": final4,
            "a5": final5,
            "a6": final6,
            "a7": final7,
            "a8": final8,
            "a9": final9,
            "a10": final10,
            "a11": final11,
            "a12": final12,
            "r1": finalr1,
            "r2": finalr2,
            "r3": finalr3,
            "r4": finalr4,
            "r5": finalr5,
            "r6": finalr6,
            "r7": finalr7,
            "r8": finalr8,
            "r9": finalr9,
            "r10": finalr10,
            "r11": finalr11,
            "r12": finalr12
        }

        setBox(data);
        return final.join();
    }






    // console.log(post,"postpostpost")

    useEffect(() => {
        getUserData();

    }, []);


    const [mainImageIndex, setMainImageIndex] = useState(0);

    // const handleImageClick = (index) => {
    //     setMainImageIndex(index);
    // };

    const [isZoomed, setIsZoomed] = useState(false)
    const handleImageClick = () => setIsZoomed(true);
    const closeZoom = () => setIsZoomed(false);

    // Determine image source
    // const imgSrc = profileimg.length
    //     ? config.API + "/images/user/" + post.photopath[0]
    //     : ("sex" in post && post.sex === "Male"
    //         ? require('../../assests/images/man.png')
    //         : require('../../assests/images/woman.png'));

    const incomeRanges = [
        { value: "0-5", title: "₹0 to ₹5 Lakh yearly" },
        { value: "5-10", title: "₹5 Lakh to ₹10 Lakh yearly" },
        { value: "10-15", title: "₹10 Lakh to ₹15 Lakh yearly" },
        { value: "15-20", title: "₹15 Lakh to ₹20 Lakh yearly" },
        { value: "20-25", title: "₹20 Lakh to ₹25 Lakh yearly" },
        { value: "25-30", title: "₹25 Lakh to ₹30 Lakh yearly" },
        { value: "30-35", title: "₹30 Lakh to ₹35 Lakh yearly" },
        { value: "35-40", title: "₹35 Lakh to ₹40 Lakh yearly" },
        { value: "40-45", title: "₹40 Lakh to ₹45 Lakh yearly" },
        { value: "45-50", title: "₹45 Lakh to ₹50 Lakh yearly" },
        { value: "50-55", title: "₹50 Lakh to ₹55 Lakh yearly" },
        { value: "55-60", title: "₹55 Lakh to ₹60 Lakh yearly" },
        { value: "60-65", title: "₹60 Lakh to ₹65 Lakh yearly" },
        { value: "65-70", title: "₹65 Lakh to ₹70 Lakh yearly" },
        { value: "70-75", title: "₹70 Lakh to ₹75 Lakh yearly" },
        { value: "75-80", title: "₹75 Lakh to ₹80 Lakh yearly" },
        { value: "80-85", title: "₹80 Lakh to ₹85 Lakh yearly" },
        { value: "85-90", title: "₹85 Lakh to ₹90 Lakh yearly" },
        { value: "90-95", title: "₹90 Lakh to ₹95 Lakh yearly" },
        { value: "95-100", title: "₹95 Lakh to ₹1 Cr yearly" },
        { value: "100+", title: "₹1 Cr+ yearly" },
        { value: "prefer-not-to-say", title: "Prefer not to say" }
    ];

    const occupations = [
        { title: "CxO / Chairman / Director / President", value: "CxO / Chairman / Director / President" },
        { title: "VP / AVP / GM / DGM", value: "VP / AVP / GM / DGM" },
        { title: "Sr. Manager / Manager", value: "Sr. Manager / Manager" },
        { title: "Consultant / Supervisor / Team Leads", value: "Consultant / Supervisor / Team Leads" },
        { title: "Team Member / Staff", value: "Team Member / Staff" },

        { title: "Air Hostess / Flight Attendant", value: "Air Hostess / Flight Attendant" },
        { title: "Pilot / Co-Pilot", value: "Pilot / Co-Pilot" },

        { title: "Architect", value: "Architect" },
        { title: "Interior Designer", value: "Interior Designer" },
        { title: "Landscape Architect", value: "Landscape Architect" },

        { title: "Animator", value: "Animator" },
        { title: "Commercial Artist", value: "Commercial Artist" },
        { title: "Web / UX Designers", value: "Web / UX Designers" },

        { title: "Beautician", value: "Beautician" },
        { title: "Fashion Designer", value: "Fashion Designer" },
        { title: "Hairstylist", value: "Hairstylist" },
        { title: "Jewellery Designer", value: "Jewellery Designer" },

        { title: "Customer Support / BPO / KPO Professional", value: "Customer Support / BPO / KPO Professional" },

        { title: "IAS / IRS / IES / IFS", value: "IAS / IRS / IES / IFS" },
        { title: "Indian Police Services [IPS]", value: "Indian Police Services [IPS]" },

        { title: "Airforce", value: "Airforce" },
        { title: "Army", value: "Army" },
        { title: "Navy", value: "Navy" },

        { title: "Lecturer", value: "Lecturer" },
        { title: "Professor", value: "Professor" },
        { title: "Research Assistant", value: "Research Assistant" },
        { title: "Research Scholar", value: "Research Scholar" },
        { title: "Teacher", value: "Teacher" },

        { title: "Civil Engineer", value: "Civil Engineer" },
        { title: "Electronics / Telecom Engineer", value: "Electronics / Telecom Engineer" },
        { title: "Mechanical / Production Engineer", value: "Mechanical / Production Engineer" },

        { title: "Chef / Sommelier / Food Critic", value: "Chef / Sommelier / Food Critic" },
        { title: "Catering Professional", value: "Catering Professional" },

        { title: "Software Developer / Programmer", value: "Software Developer / Programmer" },
        { title: "Software Consultant", value: "Software Consultant" },
        { title: "Hardware & Networking professional", value: "Hardware & Networking professional" },

        { title: "Lawyer", value: "Lawyer" },
        { title: "Legal Assistant", value: "Legal Assistant" },

        { title: "Dentist", value: "Dentist" },
        { title: "Doctor", value: "Doctor" },
        { title: "Medical Transcriptionist", value: "Medical Transcriptionist" },
        { title: "Nurse", value: "Nurse" },
        { title: "Pharmacist", value: "Pharmacist" },
        { title: "Physician Assistant", value: "Physician Assistant" },
        { title: "Physiotherapist / Occupational Therapist", value: "Physiotherapist / Occupational Therapist" },
        { title: "Psychologist", value: "Psychologist" },
        { title: "Surgeon", value: "Surgeon" },
        { title: "Veterinary Doctor", value: "Veterinary Doctor" },

        { title: "Merchant Naval Officer", value: "Merchant Naval Officer" },
        { title: "Mariner", value: "Mariner" },

        { title: "Marketing Professional", value: "Marketing Professional" },
        { title: "Sales Professional", value: "Sales Professional" },

        { title: "Biologist / Botanist", value: "Biologist / Botanist" },
        { title: "Physicist", value: "Physicist" },
        { title: "No Job", value: "No Job" },
        { title: "Others", value: "Others" },
    ];

    const educationOptions = [
        { title: "High School", value: "High School" },
        { title: "Higher Secondary", value: "Higher Secondary" },
        { title: "Diploma", value: "Diploma" },
        { title: "Bachelor's Degree", value: "Bachelor's Degree" },
        { title: "Master's Degree", value: "Master's Degree" },
        { title: "MBA", value: "MBA" },
        { title: "MCA", value: "MCA" },
        { title: "B.Tech", value: "B.Tech" },
        { title: "M.Tech", value: "M.Tech" },
        { title: "MBBS", value: "MBBS" },
        { title: "MD", value: "MD" },
        { title: "PhD", value: "PhD" },
        { title: "CA (Chartered Accountant)", value: "CA" },
        { title: "CS (Company Secretary)", value: "CS" },
        { title: "ICWA", value: "ICWA" },
        { title: "LLB", value: "LLB" },
        { title: "LLM", value: "LLM" },
        { title: "B.Arch", value: "B.Arch" },
        { title: "M.Arch", value: "M.Arch" },
        { title: "B.Sc", value: "B.Sc" },
        { title: "M.Sc", value: "M.Sc" },
        { title: "B.Com", value: "B.Com" },
        { title: "M.Com", value: "M.Com" },
        { title: "BA", value: "BA" },
        { title: "MA", value: "MA" },
        { title: "BBA", value: "BBA" },
        { title: "BCA", value: "BCA" },
        { title: "Others", value: "Others" },
    ];

    const sectors = [
        { title: "Private Sector - IT/Software", value: "Private Sector - IT/Software" },
        { title: "Private Sector - MNC", value: "Private Sector - MNC" },
        { title: "Private Sector - Corporate", value: "Private Sector - Corporate" },
        { title: "Private Sector - Others", value: "Private Sector - Others" },

        { title: "Government - Central Government", value: "Government - Central Government" },
        { title: "Government - State Government", value: "Government - State Government" },
        { title: "Government - PSU (Public Sector Undertaking)", value: "Government - PSU" },
        { title: "Government - Defence", value: "Government - Defence" },
        { title: "Government - Others", value: "Government - Others" },

        { title: "Business / Self-Employed", value: "Business / Self-Employed" },
        { title: "Not Working", value: "Not Working" },
        { title: "Others", value: "Others" },
    ];

    const requestToUserhoroscope = async (id) => {
        const token = localStorage.getItem("user_token");
        if (!token) {
            return;
        }
        try {
            const response = await userhoroscoperequest(id);

            if (response.error) {
                swal("Error", response.error, "error");
            } else {
                swal("Success", "Your request submitted successfully.", "success");
            }
        } catch (error) {
            console.error("Submit error:", error);
            swal("Error", "Failed to submit request. Please try again.", "error");
        }
    };

    return (

        // <div className="container" style={{ marginTop: "40px" }}>
        //     <div className="App">
        //         {showPopup ? (
        //             <div className="popup" onClick={(e) => closeModal(e)}>
        //                 {userpackages ?
        //                     <div className="popup_inner">
        //                         <h2>Current Package : <span style={{ color: "black", fontWeight: "700" }}>{userpackages.package}</span></h2>
        //                         <h2>Total number : <span style={{ color: "black", fontWeight: "700" }}>{userpackages.totalcount}</span></h2>
        //                         <h2>Viewed Count : <span style={{ color: "black", fontWeight: "700" }}>{userpackages.viewedcount}</span></h2>
        //                         <h2>Remaining Count : <span style={{ color: "black", fontWeight: "700" }}>{userpackages.remainingcount}</span></h2>
        //                         <div className="buttons">
        //                             <button className="btclose" onClick={showprofile}>
        //                                 Show
        //                             </button>
        //                             <button className="btclose" onClick={togglePopup}>
        //                                 Cancel
        //                             </button>
        //                         </div>
        //                     </div> : null
        //                 }
        //             </div>
        //         ) : null}
        //     </div>


        //     <a onClick={() => navigate(-1)}><button className='theri'>Go Back</button></a>

        //     <div className="pizza" >

        //         <p className='water'>{post.mname}<span className='spank'>( {post.userid} )</span></p>



        //         <div className="row" style={width <= 774 ? { height: 'auto' } : { height: '360px' }}>

        //             <div className="col-md-12 sm-12">

        //                 <div className='container'>
        //                     <div className="row " >

        //                         <div className="col-md-6 col-lg-4">
        //                             <div className='dontdon'>
        //                                 {profileimg.length ? (
        //                                     <img
        //                                         className="logo viewphotoz"
        //                                         style={{
        //                                             marginTop: "15px",
        //                                             border: 'none'
        //                                         }}
        //                                         src={config.API + "/images/user/" + post.photopath[mainImageIndex]}
        //                                         alt="Main"
        //                                     />
        //                                 ) : (
        //                                     <img
        //                                         className='donzz'
        //                                         src={"sex" in post && post.sex === "Male" ? require('../../assests/images/man.png') : require('../../assests/images/woman.png')}
        //                                         alt="Fallback"
        //                                     />
        //                                 )}
        //                             </div>

        //                             {post.photopath?.length > 1 && (
        //                                 <div className="additional-images-container" style={{ display: 'flex', overflowX: 'auto', marginTop: '10px', paddingBottom: '5px' }}>
        //                                     {post.photopath.map((imgPath, index) => (
        //                                         <img
        //                                             key={index}
        //                                             className="additional-image"
        //                                             src={config.API + "/images/user/" + imgPath}
        //                                             style={{
        //                                                 width: '80px',
        //                                                 height: '80px',
        //                                                 marginRight: '10px',
        //                                                 objectFit: 'cover',
        //                                                 cursor: 'pointer',
        //                                                 border: index === mainImageIndex ? '3px solid #029c09' : 'none' // Highlight selected image
        //                                             }}
        //                                             alt={`Thumbnail ${index + 1}`}
        //                                             onClick={() => handleImageClick(index)}
        //                                         />
        //                                     ))}
        //                                 </div>
        //                             )}
        //                         </div>



        //                         <div className="col-md-6 col-lg-4 content">
        //                             <table className='AnDroid' >
        //                                 <tbody>
        //                                     <tr >
        //                                         <td className='billa'>Name</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.mname}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Gender</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.sex == 'Male' ? "Male" : "Female"}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Age </td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.age = new Date().getFullYear() - post.year + "" + " Yrs"}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Education</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.educ}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Caste</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'> {post.castename}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Sub Caste</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.subcaste}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>District </td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'> {post.city}</td>
        //                                     </tr>

        //                                     <tr   >
        //                                         <td className='billa'>Marital Status</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.maritalname == "Marriage" ? "First Marriage" : "Remarriage"}</td>
        //                                     </tr>
        //                                     {post.maritalname == "Marriage" ?
        //                                         <tr className="hide">
        //                                             <td className='billa'>Children</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.children}</td>
        //                                         </tr>
        //                                         :
        //                                         <tr>
        //                                             <td className='billa'>Children</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.children}</td>
        //                                         </tr>}
        //                                 </tbody>
        //                             </table>
        //                         </div>

        //                         <div className="col-md-6 col-lg-4 content">
        //                             <table className="sans" >
        //                                 <tbody>
        //                                     <tr>
        //                                         <td className='billa'>Date of Birth</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.dob = post.date + "-" + post.month + "-" + post.year}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Height</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.height}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Color</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.colorname}</td>
        //                                     </tr>

        //                                     <tr>
        //                                         <td className='billa'>Occupation</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.occup}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Monthly Income</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>	{post.income}</td>
        //                                     </tr>
        //                                     {post.maritalname == "Marriage" ?
        //                                         <tr className="hide">
        //                                             <td className='billa'>Remarriage reason</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.n_marriage}</td>
        //                                         </tr>
        //                                         :
        //                                         <tr>
        //                                             <td className='billa'>Remarriage reason</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.n_marriage}</td>
        //                                         </tr>}
        //                                     {post.maritalname == "Marriage" || post.children == "No" ?
        //                                         <tr className="hide">
        //                                             <td className='billa'>Children Details</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.child_detail}</td>
        //                                         </tr>
        //                                         :
        //                                         <tr>
        //                                             <td className='billa'>Children Details</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.child_detail}</td>
        //                                         </tr>}

        //                                     <tr>
        //                                         <td className='billa'>No Caste restriction</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>	{post.castenone}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Disabled</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'> {post.handireason == "" ? "No" : 'Yes'}</td>
        //                                     </tr>
        //                                     {post.handireason ?
        //                                         <tr>
        //                                             <td className='billa'>Details</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>	{post.handireason}</td>
        //                                         </tr>
        //                                         : null}

        //                                 </tbody>
        //                             </table>
        //                         </div>

        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>


        //     <div className="centerFruit" >
        //         <div className='container'>

        //             <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>

        //                 <div className="col-md-12 sm-12 ">

        //                     <p className='name1'>Family Details</p>

        //                     <div className="row " >

        //                         <div className="col-md-6 ">

        //                             <table className='Boomer' >


        //                                 <tbody><tr>
        //                                     <td className='billa1'>Father's Name</td>
        //                                     <td className='kuruvi1'>:</td>
        //                                     <td className='alan1'>{post.father_name}</td>
        //                                 </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Mother's Name</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.mother_name}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Father's Occupation</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.dad_work}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Mother's Occupation</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.mom_work}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Siblings (Including this person)</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.brother}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Married Brothers</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.m_brother}</td>
        //                                     </tr>

        //                                 </tbody></table>
        //                         </div>
        //                         <div className="col-md-6 content">
        //                             <table className='Boomer' >
        //                                 <tbody>
        //                                     <tr>
        //                                         <td className='billa1'>Sisters (Including this person)</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.sister}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Married Sisters</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.m_sister}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Registered By</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.regis}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Origin</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.puriveaam}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Assets</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.peroparty}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Dowry Details</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.dever} </td>
        //                                     </tr>


        //                                 </tbody>
        //                             </table>


        //                         </div>


        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>







        //     {membership ?
        //         <div>



        //             <div className="centerFruit" >

        //                 <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
        //                     <div className="col-md-12 sm-12">

        //                         <p className='name1'>Horoscope Details</p>

        //                         <div className="row " >

        //                             <div className="col-md-6 ">

        //                                 <table className='Boomer' >


        //                                     <tbody><tr>
        //                                         <td className='billa'>Star</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.starname}</td>
        //                                     </tr>
        //                                         <tr>
        //                                             <td className='billa'>Zodiac</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.zodiacname}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Lagna</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.gothra}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Direction</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.directionname}</td>
        //                                         </tr>


        //                                     </tbody></table>
        //                             </div>
        //                             <div className="col-md-6 content">
        //                                 <table className='Boomer' >
        //                                     <tbody>
        //                                         <tr>
        //                                             <td className='billa'>Year</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'> {post.s_year}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Month</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'> {post.s_month}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Day</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.s_day}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Patham</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.patham}</td>
        //                                         </tr>

        //                                     </tbody>
        //                                 </table>


        //                             </div>


        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>


        //             <div className style={{ marginTop: '30px' }}>
        //                 <img src={require('../../assests/images/chat_new_en.png')} className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto' }} />
        //                 <div className="form-group table-responsive" style={{ fontSize: "17px" }}>
        //                     <table className="rassi-table" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: '50px' }}>
        //                         <tbody>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r1)}
        //                                         id="r1"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r2)}
        //                                         id="r2"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r3)}
        //                                         id="r3"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r4)}
        //                                         id="r4"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a1)}
        //                                         id="a1"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a2)}
        //                                         id="a2"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a3)}
        //                                         id="a3"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a4)}
        //                                         id="a4"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r5)}
        //                                         id="r5"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td colspan="2" rowspan="2" width="124" align="center">
        //                                     <img src={require('../../assests/images/raaasi_en.png')} width={112} height={45} />
        //                                 </td>
        //                                 <td><textarea
        //                                     value={(r6)}
        //                                     id="r6"
        //                                     readonly
        //                                     style={{ textAlign: "center" }}
        //                                     minRows={3}
        //                                     Cols={8}
        //                                     formControlProps={{
        //                                         fullWidth: true,
        //                                     }} />
        //                                 </td>
        //                                 <div style={{ marginLeft: "15px" }}></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a5)}
        //                                         id="a5"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td rowspan="2" colspan="2" width="133" align="center">
        //                                     <img src={require('../../assests/images/amsam_en.png')} width={112} height={45} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a6)}
        //                                         id="a6"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r7)}
        //                                         id="r7"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r8)}
        //                                         id="r8"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a7)}
        //                                         id="a7"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td width="57" height="63" align="center">
        //                                     <textarea
        //                                         value={(a8)}
        //                                         id="a8"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r9)}
        //                                         id="r9"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r10)}
        //                                         id="r10"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r11)}
        //                                         id="r11"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r12)}
        //                                         id="r12"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a9)}
        //                                         id="a9"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a10)}
        //                                         id="a10"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a11)}
        //                                         id="a11"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a12)}
        //                                         id="a12"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                         </tbody>
        //                     </table>
        //                 </div>
        //             </div>


        //             <div className="centerFruit" >

        //                 <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
        //                     <div className="col-md-12 sm-12 ">

        //                         <p className='name1'>Contact Details</p>

        //                         <div className="row " >

        //                             <div className="col-md-12 ">

        //                                 <table className='Boomer' >


        //                                     <tbody><tr>
        //                                         <td className='billa'>Phone Number</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.phone_number}</td>
        //                                     </tr>
        //                                         <tr>
        //                                             <td className='billa'>Address</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.address}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Email Address</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.email_id}</td>
        //                                         </tr>

        //                                     </tbody></table>
        //                             </div>


        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>

















        //         </div>

        //         :

        //         <div>
        //             <div className="centerFruit" >

        //                 <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
        //                     <div className="col-md-12 sm-12">

        //                         <p className='name1'>Horoscope Details</p>

        //                         <div className="row " >

        //                             <div className="col-md-6 ">

        //                                 <table className='Boomer' >


        //                                     <tbody><tr>
        //                                         <td className='billa'>Star</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.starname}</td>
        //                                     </tr>
        //                                         <tr>
        //                                             <td className='billa'>Zodiac</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.zodiacname}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Lagna</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.gothra}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Direction</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.directionname}</td>
        //                                         </tr>


        //                                     </tbody></table>
        //                             </div>
        //                             <div className="col-md-6 content">
        //                                 <table className='Boomer' >
        //                                     <tbody>
        //                                         <tr>
        //                                             <td className='billa'>Year</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'> {post.s_year}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Month</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'> {post.s_month}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Day</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.s_day}</td>
        //                                         </tr>
        //                                         <tr>
        //                                             <td className='billa'>Patham</td>
        //                                             <td className='kuruvi'>:</td>
        //                                             <td className='alan'>{post.patham}</td>
        //                                         </tr>

        //                                     </tbody>
        //                                 </table>


        //                             </div>


        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>


        //             <div className style={{ marginTop: '30px' }}>
        //                 <img src={require('../../assests/images/chat_new_en.png')} className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto' }} />
        //                 <div className="form-group table-responsive" style={{ fontSize: "17px" }}>
        //                     <table className="rassi-table" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: '50px' }}>
        //                         <tbody>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r1)}
        //                                         id="r1"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r2)}
        //                                         id="r2"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r3)}
        //                                         id="r3"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r4)}
        //                                         id="r4"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a1)}
        //                                         id="a1"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a2)}
        //                                         id="a2"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a3)}
        //                                         id="a3"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a4)}
        //                                         id="a4"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r5)}
        //                                         id="r5"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td colspan="2" rowspan="2" width="124" align="center">
        //                                     <img src={require('../../assests/images/raaasi_en.png')} width={112} height={45} />
        //                                 </td>
        //                                 <td><textarea
        //                                     value={(r6)}
        //                                     id="r6"
        //                                     readonly
        //                                     style={{ textAlign: "center" }}
        //                                     minRows={3}
        //                                     Cols={8}
        //                                     formControlProps={{
        //                                         fullWidth: true,
        //                                     }} />
        //                                 </td>
        //                                 <div style={{ marginLeft: "15px" }}></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a5)}
        //                                         id="a5"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td rowspan="2" colspan="2" width="133" align="center">
        //                                     <img src={require('../../assests/images/amsam_en.png')} width={112} height={45} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a6)}
        //                                         id="a6"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r7)}
        //                                         id="r7"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r8)}
        //                                         id="r8"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a7)}
        //                                         id="a7"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td width="57" height="63" align="center">
        //                                     <textarea
        //                                         value={(a8)}
        //                                         id="a8"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                             <tr>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r9)}
        //                                         id="r9"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r10)}
        //                                         id="r10"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r11)}
        //                                         id="r11"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(r12)}
        //                                         id="r12"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <div></div>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a9)}
        //                                         id="a9"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a10)}
        //                                         id="a10"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a11)}
        //                                         id="a11"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                                 <td>
        //                                     <textarea
        //                                         value={(a12)}
        //                                         id="a12"
        //                                         readonly
        //                                         style={{ textAlign: "center" }}
        //                                         minRows={3}
        //                                         Cols={8}
        //                                         formControlProps={{
        //                                             fullWidth: true,
        //                                         }} />
        //                                 </td>
        //                             </tr>
        //                         </tbody>
        //                     </table>
        //                 </div>
        //             </div>






        //         </div>
        //     }

        //     <button onClick={show} className='burg' style={{ display: savenone }}>{moredetailbtn}<FavoriteIcon style={{ height: '19px', width: '19px', marginLeft: '5px', marginBottom: '2px', marginTop: "0px" }} /></button>

        // </div>

        <div className="container container-top">
            <div class="topright-hide" style={{ textAlign: 'left' }}>
                <img src={whyeliteLeft} class="whyelite-left-img" alt="Elite Arrow" />
            </div>
            <div className="textCenter" >
                {post.membership ? <button className='theri'>{post.membership} Package</button> : null}
            </div>
            <div className="App">
                {/* <button className='kuselan' onClick={togglePopup}>Edit Profile</button> */}
                {showPopup ? (
                    <div className="popup" onClick={(e) => closeModal(e)}>
                        <div className="popup_inner">
                            <h2 style={{ color: "black", fontWeight: "bold" }}>You can change your details, contact your admin.</h2>
                            <h2 style={{ color: "black", fontWeight: "bold", marginTop: "25px" }}>Call: 96529 66888 </h2>
                            <button className="close" onClick={togglePopup}>
                                Close
                            </button>
                        </div>
                    </div>
                ) : null}
            </div>
            {/* Basic Info - always visible */}
            <div className="centerFruit container" style={{ flexWrap: 'inherit' }}>
                {isLoggedIn ?
                    <span>
                        {!hasMembership && (
                            <a href="/payment">
                                <h2 style={{ color: 'red', textDecoration: 'underline' }}>Please get membership to view full details</h2>
                            </a>
                        )}
                    </span>
                    :
                    <span>
                        <a onClick={handleOpen} style={{ pointerEvents: "auto", cursor: "pointer" }}>
                            <h2 style={{ color: 'red', textDecoration: 'underline' }}>Please login to view details</h2>
                        </a>
                    </span>
                }

                <div className="row whole-div">
                    {/* Column 1 */}
                    <div className="col-12 col-md-8 mb-3">
                        {/* <div className="flex-item">
                            <p className='valimai text-uppercase'>
                                {post.mname}
                                <p className='spank'>( {post.userid} )</p>
                            </p>
                        </div> */}
                        <div className='dark-beige'>
                            <span className='heading'>
                                <strong>PERSONAL INFORMATION</strong>
                            </span>
                        </div>
                        <div className="centerFruit container text-uppercase">
                            <div className="row">
                                <div className="col-12 col-md-8-custom mb-3 border-end">
                                    <table className="AnDroid w-100">
                                        <tbody>
                                            <tr>
                                                <td className="billa">Name</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.mname}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Age</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{calculateAge(post.dob)} Yrs</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Gender</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.sex}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Marital Status</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.maritalname === "Marriage" ? "First marriage" : "Remarriage"}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Caste</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.castename}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Sub Caste</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.subcaste}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Place of Residence</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.place_of_residence}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Place of Birth</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.place_of_birth}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Date of Birth</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{new Date(post.dob).toLocaleDateString('en-IN')}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Height</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.height}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Color</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.colorname}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Caste Restriction</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.castenone}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Disability</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.different}</td>
                                            </tr>
                                            {post.comment && 
                                            <tr>
                                                <td className="billa">About</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.comment}</td>
                                            </tr>}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-3 mb-3">
                                    {isLoggedIn &&
                                        (
                                            <button onClick={savefavprofile} style={{ display: createwishlistbtn }} className='drink'>Save Profile
                                                <br />
                                                <FavoriteIcon style={{ fontSize: '14px', margin: "0px 0px 0px 8px" }} />
                                            </button>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Column 2 */}
                    <div className="col-12 col-md-4" style={{ alignContent: 'center' }}>
                        {/* <BlurWrapper condition={isLoggedIn}> */}
                        <ImageSlider post={post} config={config} />
                        {/* </BlurWrapper> */}
                    </div>

                    {/* Column 3 */}
                    {/* <div className="col-12 col-md-4 mb-3">
                        <BlurWrapper condition={hasMembership}>
                            <div className="flex-item">
                                <h1 style={{ textAlign: 'left' }}>
                                    <strong>CONTACT INFORMATION</strong>
                                </h1>
                                <table className='Boomer'>
                                    <tbody>
                                        <tr>
                                            <td className='alan'>
                                                <i className="fa-solid fa-phone" style={{ color: 'black', padding: '10px' }}></i>
                                                {post.phone_number}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='alan'>
                                                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                    <i className="fa-solid fa-location-dot" style={{ color: 'black', padding: '10px', paddingTop: '5px' }}></i>
                                                    <span>{post.address}</span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='alan'>
                                                <i className="fa-solid fa-square-envelope" style={{ color: 'black', padding: '10px' }}></i>
                                                {post.email_id}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </BlurWrapper>
                    </div> */}
                </div>

            </div>

            {/* <div className='dark-beige'>
                <span className='heading'>
                    <strong>PERSONAL INFORMATION</strong>
                </span>
            </div> */}
            {/* PERSONAL INFORMATION - visible to logged in users */}
            {/* <BlurWrapper condition={isLoggedIn}> */}
            {/* <div className="centerFruit container text-uppercase">
                <div className="row"> */}
            {/* Column 1 */}
            {/* <div className="col-12 col-md-4 mb-3 border-end">
                        <table className="AnDroid w-100">
                            <tbody>
                                <tr>
                                    <td className="billa">Name</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.mname}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Age</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{new Date().getFullYear() - post.year} Yrs</td>
                                </tr>
                                <tr>
                                    <td className="billa">Race</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.castename}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Place of Residence</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.place_of_residence}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

            {/* Column 2 */}
            {/* <div className="col-12 col-md-4 mb-3 border-end">
                        <table className="AnDroid w-100">
                            <tbody>
                                <tr>
                                    <td className="billa">Marital Status</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.maritalname === "Marriage" ? "First marriage" : "Remarriage"}</td>
                                </tr>

                                <tr>
                                    <td className="billa">Date of Birth</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.date + "/" + post.month + "/" + post.year}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Place of Birth</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.place_of_birth}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Height</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.height}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

            {/* Column 3 */}
            {/* <div className="col-12 col-md-4 mb-3">
                        <table className="AnDroid w-100">
                            <tbody>
                                <tr>
                                    <td className="billa">Color</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.colorname}</td>
                                </tr>
                                <tr>
                                    <td className="billa">District</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.city}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Subdivision</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.subcaste}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div> */}
            {/* </div>
            </div> */}
            {/* </BlurWrapper> */}

            <div className='dark-beige'>
                <span className='heading'>
                    <strong>EDUCATION/WORK EXPERIENCE</strong>
                </span>
            </div>
            {/* EDUCATION/WORK EXPERIENCE - visible to logged in users */}
            <BlurWrapper condition={isLoggedIn}>
                <div className="centerFruit container text-uppercase">
                    <div className="row">
                        <div className="col-12 col-md-4 mb-3">
                            <table className="AnDroid w-100 border-end">
                                <tbody>
                                    <tr>
                                        <td className="billa">Job/Career</td>
                                        <td className="kuruvi">:</td>
                                        {/* <td className="alan">{post.occup && (occupations.some(item => item.title === post?.occup) ? post?.occup : post?.occup + " (Others)")}</td> */}
                                        <td className="alan">{post.occup}</td>
                                    </tr>
                                    <tr>
                                        <td className="billa">Salary Income</td>
                                        <td className="kuruvi">:</td>
                                        <td className="alan">{incomeRanges.find(item => item.value === post?.income)?.title || ""}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-12 col-md-4 mb-3">
                            <table className="AnDroid w-100 border-end">
                                <tbody>
                                    <tr>
                                        <td className="billa">Work Sector</td>
                                        <td className="kuruvi">:</td>
                                        {/* <td className="alan">{post.work_sector && (sectors.some(item => item.title === post?.work_sector) ? post?.work_sector : post?.work_sector + " (Others)")}</td> */}
                                        <td className="alan">{post.work_sector}</td>
                                    </tr>
                                    <tr>
                                        <td className="billa">Company Name</td>
                                        <td className="kuruvi">:</td>
                                        <td className="alan">{post.company_name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-12 col-md-4 mb-3">
                            <table className="AnDroid w-100 border-end">
                                <tbody>
                                    <tr>
                                        <td className="billa">Educational Qualification</td>
                                        <td className="kuruvi">:</td>
                                        {/* <td className="alan">{post.educ && (educationOptions.some(item => item.title === post?.educ) ? post?.educ : post?.educ + " (Others)")}</td> */}
                                        <td className="alan">{post.educ}</td>
                                    </tr>
                                    <tr>
                                        <td className="billa">Higher Educational Qualification</td>
                                        <td className="kuruvi">:</td>
                                        <td className="alan">{post.higher_education_qualification}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </BlurWrapper>

            <div className='dark-beige'>
                <span className='heading'>
                    <strong>FAMILY INFORMATION</strong>
                </span>
            </div>
            {/* FAMILY INFORMATION - visible to members only */}
            <BlurWrapper condition={isLoggedIn}>
                <div className="centerFruit container text-uppercase">
                    <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                        <div className="col-md-12 sm-12">
                            <div className="row">

                                {/* Column 1 */}
                                <div className="col-12 col-md-4 mb-3 border-end">
                                    <table className="Boomer w-100">
                                        <tbody>
                                            <tr>
                                                <td className="billa">Father's Name</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.father_name}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Mother's Name</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.mother_name}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Father's Work</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.dad_work}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Mother's Work</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.mom_work}</td>
                                            </tr>
                                            {/* <tr>
                                            <td className="billa">Community</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.castename}</td>
                                        </tr> */}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Column 2 */}
                                <div className="col-12 col-md-4 mb-3 border-end">
                                    <table className="Boomer w-100">
                                        <tbody>
                                            <tr>
                                                <td className="billa">Brothers</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.brother}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Married Brothers</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.m_brother}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Sisters</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.sister}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Married Sisters</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.m_sister}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Column 3 */}
                                <div className="col-12 col-md-4 mb-3">
                                    <table className="Boomer w-100">
                                        <tbody>
                                            <tr>
                                                <td className="billa">Register</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.regis}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Native</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.native_place}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Assets</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.peroparty}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Dowry</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.ever}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </BlurWrapper>

            {/* ADDRESS INFORMATION - visible to members only */}
            {/* <button onClick={show} className='burg' style={{ display: savenone }}>{moredetailbtn}<FavoriteIcon style={{ height: '19px', width: '19px', marginLeft: '5px', marginBottom: '2px', marginTop: "0px" }} /></button> */}

            {isLoggedIn && canViewFullProfile ? (
                <>
                    <div className='dark-beige'>
                        <span className='heading'>
                            <strong>CONTACT INFORMATION</strong>
                        </span>
                    </div>
                    {/* <BlurWrapper condition={hasMembership}> */}
                    <div className="centerFruit container text-uppercase" >
                        <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                            <div className="col-md-12 sm-12 ">
                                <div className="row" >
                                    <div className="col-md-12 ">
                                        <table className='Boomer' >
                                            <tbody>
                                                <tr>
                                                    <td className='billa'>Mobile number</td>
                                                    <td className='kuruvi'>:</td>
                                                    <td className='alan'>{9652966888}</td>
                                                </tr>
                                                <tr>
                                                    <td className='billa'>City</td>
                                                    <td className='kuruvi'>:</td>
                                                    <td className='alan'>{post.city}</td>
                                                </tr>
                                                <tr>
                                                    <td className='billa'>Address</td>
                                                    <td className='kuruvi'>:</td>
                                                    <td className='alan'>{post.address}</td>
                                                </tr>
                                                <tr>
                                                    <td className='billa'>Place of residence</td>
                                                    <td className='kuruvi'>:</td>
                                                    <td className='alan'>{post.place_of_residence}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </BlurWrapper> */}
                    <div className='dark-beige'>
                        <span className='heading'>
                            <strong>ADDRESS INFORMATION</strong>
                        </span>
                    </div>
                    {/* <BlurWrapper condition={hasMembership}> */}
                    <div className="centerFruit container text-uppercase" >
                        <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                            <div className="col-md-12 sm-12 ">
                                <div className="row" >
                                    <div className="col-md-12 ">
                                        <table className='Boomer' >
                                            <tbody>
                                                <tr>
                                                    <td className='billa'>Mobile number</td>
                                                    <td className='kuruvi'>:</td>
                                                    <td className='alan'>{post.phone_number}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className='billa'>Address</td>
                                                    <td className='kuruvi'>:</td>
                                                    <td className='alan'>{post.address}</td>
                                                </tr>
                                                <tr>
                                                    <td className='billa'>Email address</td>
                                                    <td className='kuruvi'>:</td>
                                                    <td className='alan'>{post.email_id}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </BlurWrapper> */}

                    <div className='dark-beige'>
                        <span className='heading'>
                            <strong>HOROSCOPE INFORMATION</strong>
                        </span>
                    </div>

                    {/* <BlurWrapper condition={hasMembership}> */}
                    <div className="centerFruit container text-uppercase">
                        <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                            <div className="col-md-12 sm-12">
                                <div className="row">

                                    <div className="col-12 col-md-6 border-end mb-3">
                                        <table className="Boomer w-100">
                                            <tbody>
                                                <tr>
                                                    <td className="billa">Religion</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.religion}</td>
                                                </tr>
                                                <tr>
                                                    <td className="billa">Star</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.starname}</td>
                                                </tr>
                                                <tr>
                                                    <td className="billa">Zodiac sign</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.zodiacname}</td>
                                                </tr>
                                                <tr>
                                                    <td className="billa">Gothra</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.gothra}</td>
                                                </tr>
                                                <tr>
                                                    <td className="billa">Direction</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.directionname}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <div className="col-12 col-md-6 mb-3">
                                        <table className="Boomer w-100">
                                            <tbody>
                                                <tr>
                                                    <td className="billa">Dhosam</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.dhosam}</td>
                                                </tr>
                                                <tr>
                                                    <td className="billa">Patham</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.patham}</td>
                                                </tr>
                                                <tr>
                                                    <td className="billa">Time of Birth</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.time_of_birth}</td>
                                                </tr>
                                                <tr>
                                                    <td className="billa">Year</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.s_year}</td>
                                                </tr>
                                                <tr>
                                                    <td className="billa">Month</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.s_month}</td>
                                                </tr>
                                                <tr>
                                                    <td className="billa">Day</td>
                                                    <td className="kuruvi">:</td>
                                                    <td className="alan">{post.s_day}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="topright-hide" style={{ textAlign: 'right' }}>
                                    <img src={whyeliteRight} class="whyelite-bottom" alt="Elite Arrow"
                                        style={{ width: '12%', marginTop: '-157px', marginRight: '-16px' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </BlurWrapper> */}

                    <div className='dark-beige'>
                        <span className='heading'>
                            <strong>PHOTOS</strong>
                        </span>
                    </div>
                    {/* PHOTOS - visible to members only */}
                    {/* <BlurWrapper condition={hasMembership}> */}
                    <div className="centerFruit container">
                        <div className="flex-item" style={{ textAlign: 'center' }}>
                            {profileimg.length ? (
                                post.photopath.map((img, index) => (
                                    <img
                                        key={index}
                                        src={config.API + "/images/user/" + img}
                                        alt={`Profile ${index + 1}`}
                                        style={{
                                            float: "left",
                                            margin: "10px",
                                            width: "200px",
                                            height: "200px",
                                            objectFit: "fit",
                                        }}
                                    />
                                ))
                            ) : (
                                <img
                                    src={
                                        "sex" in post && post.sex === "Male"
                                            ? require('../../assests/images/man.png')
                                            : require('../../assests/images/woman.png')
                                    }
                                    style={{
                                        float: "left",
                                        margin: "10px",
                                        width: "200px",
                                        height: "200px",
                                        objectFit: "fit",
                                    }}
                                    alt="Default"
                                />
                            )}
                        </div>
                    </div>
                    {/* </BlurWrapper> */}

                    {/* RAAASI TABLE - visible to members only */}
                    {/* <BlurWrapper condition={hasMembership}> */}
                    <div className style={{ marginTop: '0px' }}>
                        <img src={require('../../assests/images/chat_new_en.png')} className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                        <div className="form-group table-responsive" style={{ fontSize: "17px" }}>
                            <table className="rassi-table" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: '50px' }}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <textarea
                                                value={(r1)}
                                                id="r1"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(r2)}
                                                id="r2"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(r3)}
                                                id="r3"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(r4)}
                                                id="r4"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <div style={{ margin: '30px' }}></div>
                                        <td>
                                            <textarea
                                                value={(a1)}
                                                id="a1"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(a2)}
                                                id="a2"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(a3)}
                                                id="a3"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(a4)}
                                                id="a4"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <textarea
                                                value={(r5)}
                                                id="r5"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td colspan="2" rowspan="2" width="124" align="center">
                                            <img src={require('../../assests/images/raaasi_en.png')} width={112} height={45} />
                                        </td>
                                        <td><textarea
                                            value={(r6)}
                                            id="r6"
                                            readonly
                                            style={{ textAlign: "center" }}
                                            minRows={3}
                                            Cols={8}
                                            formControlProps={{
                                                fullWidth: true,
                                            }} />
                                        </td>
                                        <div style={{ marginLeft: "15px" }}></div>
                                        <td>
                                            <textarea
                                                value={(a5)}
                                                id="a5"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td rowspan="2" colspan="2" width="133" align="center">
                                            <img src={require('../../assests/images/amsam_en.png')} width={112} height={45} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(a6)}
                                                id="a6"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <textarea
                                                value={(r7)}
                                                id="r7"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(r8)}
                                                id="r8"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <div></div>
                                        <td>
                                            <textarea
                                                value={(a7)}
                                                id="a7"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td width="57" height="63" align="center">
                                            <textarea
                                                value={(a8)}
                                                id="a8"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <textarea
                                                value={(r9)}
                                                id="r9"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(r10)}
                                                id="r10"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(r11)}
                                                id="r11"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(r12)}
                                                id="r12"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <div></div>
                                        <td>
                                            <textarea
                                                value={(a9)}
                                                id="a9"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(a10)}
                                                id="a10"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(a11)}
                                                id="a11"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                        <td>
                                            <textarea
                                                value={(a12)}
                                                id="a12"
                                                readonly
                                                style={{ textAlign: "center" }}
                                                minRows={3}
                                                Cols={8}
                                                formControlProps={{
                                                    fullWidth: true,
                                                }} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {post.jathagampic?.length > 0 && (
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "50px" }}>
                                {Array.isArray(post.jathagampic) ?
                                    post.jathagampic.map((img, index) => (
                                        <img key={index} src={config.API + "/images/user/" + img} alt={`Jathagam ${index + 1}`} className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: "20px" }} />
                                    )) :
                                    <>
                                        <img src={config.API + "/images/user/" + post.jathagampic} alt="Jathagam" className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: "20px" }} />
                                    </>}
                            </div>
                        )}
                    </div>
                    {/* </BlurWrapper> */}

                </>
            ) :
                <div className="centerFruit container" style={{ display: "flex" }}>
                    {hasMembership ?
                        <button
                            onClick={() => requestToUserhoroscope(post._id)}
                            className='buttonsss'
                            style={{ border: "0px solid #B21919" }}
                        // disabled={!hasMembership}
                        >Send Request for Full Profile
                        </button> :
                        <button
                            onClick={() => window.location.href = "/membership"}
                            className='buttonsss'
                            style={{ border: "0px solid #B21919" }}
                        >Buy Membership to send Request for Full Profile
                        </button>
                    }
                </div>
            }


            <style jsx>
                {`
                @media (max-width: 425px) {
                    .container-top{
                        margin-top: 60px  !important;
                    }
                }`}
            </style>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Button className='timee'
                        style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            width: "35px",
                            height: "35px",
                            minWidth: "35px",
                            color: "#BA3E3E",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            zIndex: 10,
                        }} onClick={handleClose} variant="primary">
                        <CancelIcon className='rasathi' />
                    </Button>
                    <Tabp />
                </Box>
            </Modal>
        </div>

    )
}

export default Freesearch;